export default function getEnabledItems<T>(items: (T & { enabled?: boolean })[]) {
  return items.filter((item) => item.enabled).map(({ enabled, ...rest }) => rest) as T[];
}
